import React, { useCallback } from 'react';
import { useRequests } from '../../contexts/RequestsContext';
import { binRequest } from '../../data/binRequest';
import { useCollecteConversation, type CollecteKind } from '../../hooks/useCollecteConversation';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { CollecteMessage } from './CollecteMessage';
interface CollecteDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
}
export function CollecteDialog({
  initialText,
  onClose,
  layoutId
}: CollecteDialogProps) {
  const {
    addRequest
  } = useRequests();
  // Le signalement crée la requête, qui apparaît aussitôt dans « Mes demandes ».
  const openRequest = useCallback(() => addRequest(binRequest), [addRequest]);
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    attachPhoto,
    photoAttached,
    liveAtnaId,
    lastAtnaKind
  } = useCollecteConversation(initialText, openRequest);
  return <AtnaDialogShell layoutId={layoutId} subtitle="Collectes" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA peut se tromper. Vérifiez le suivi de votre requête dans Mes demandes." prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    onAddPhoto: attachPhoto,
    photoAttached,
    placeholder: lastAtnaKind === 'reponse' ? 'Décrire un problème de collecte…' : 'Ajouter une précision à votre requête…'
  }} renderAtna={(kind, live) => <CollecteMessage kind={kind as CollecteKind} live={live} photoAttached={photoAttached} onAddPhoto={attachPhoto} data-id="element-671" data-mp="27k7z1ay4rk8e" />} data-id="element-670" data-mp="2hc410x3c7uhw" />;
}